import React from "react";
import { ReactComponent as CloseIcon } from "assets/login/closeIcon.svg";

interface Props {
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
  placeholder: string;
  type?: string;
  onKeyPress?: React.KeyboardEventHandler<HTMLInputElement>;
}

export function LoginInput({
  type = "text",
  value,
  setValue,
  placeholder,
  onKeyPress,
}: Props) {
  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  const handleResetBtn = () => {
    setValue("");
  };

  return (
    <div className="flex h-[52px] w-full items-center justify-between border-[1px] border-gray-1 bg-white p-[16px] focus-within:border-black">
      <input
        value={value}
        onChange={handleInput}
        type={type}
        placeholder={placeholder}
        onKeyPress={onKeyPress}
        className="m-0 w-[90%] border-none bg-white p-0 text-R1 text-black outline-none placeholder:text-gray-2 focus:ring-0"
      />
      {value && (
        <CloseIcon className="cursor-pointer" onClick={handleResetBtn} />
      )}
    </div>
  );
}
